import { useEffect, useState } from 'react';
import { Bars } from 'react-loader-spinner';
import { useJurisdictions } from '../../../../hooks/useJurisdictions';
import { useTranslation } from 'react-i18next';

interface JurisdictionSelectProps {
  selectedJurisdictionId: number | null;
  setSelectedJurisdictionId: (id: number) => void;
}

export const JurisdictionSelect = ({
  selectedJurisdictionId,
  setSelectedJurisdictionId,
}: JurisdictionSelectProps) => {
  const { jurisdictions, loading } = useJurisdictions();

  const { t } = useTranslation();

  useEffect(() => {
    if (jurisdictions.length > 0 && selectedJurisdictionId === null) {
      setSelectedJurisdictionId(jurisdictions[0].jurisdiction_id);
    }
  }, [jurisdictions, selectedJurisdictionId, setSelectedJurisdictionId]);

  if (loading)
    return (
      <div className="flex items-center justify-center py-6">
        <Bars height="32" width="32" color="#4B5563" />
      </div>
    );

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm">{t('config.TargetJuridiction')}:</label>
      <select
        className="border rounded px-3 py-2 w-full"
        value={selectedJurisdictionId || ''}
        onChange={(e) => {
          setSelectedJurisdictionId(Number(e.target.value));
        }}
      >
        {jurisdictions
          .filter((j) => j.is_active === 1)
          .map((jurisdiction: any) => (
            <option key={jurisdiction.jurisdiction_id} value={jurisdiction.jurisdiction_id}>
              {jurisdiction.jurisdiction_description}
            </option>
          ))}
      </select>
    </div>
  );
};
